<template>
  <div class="regulatory-footer-wrapper" :class="{'centralized' : isCentralized}">
    <span v-if="showBalance">Přehled čistých proher: {{currency}} {{ balance | convertToMajorBalance }}</span>
    <span v-else></span>
    <span>Účast na hazardní hře může být škodlivá</span>
    <button v-if="userDevice === 'd'" @click="$store.dispatch('toggleFullscreen')" class="button-fullscreen">
      <font-awesome-icon :icon="icon" color="white" size="2xl" />
    </button>
  </div>
</template>

<script>
import convertToMajorBalance from '@/mixins/filterMajorBalance'

export default {
  name: 'CZRegulatoryFooter',
  data: () => ({ isCentralized: false }),
  props: {
    isInitialBetPlayed: { type: Boolean, required: true },
    balance: { type: [String, Number], default: '0' },
    currency: { type: String, default: '' },
    userDevice: { type: String, default: 'd' }
  },
  mixins: [convertToMajorBalance],
  created () { this.$store.dispatch('setFullScreenEvents'); },
  computed: {
    isFullScreen: vm => vm.$store.getters.isFullScreen,
    icon: vm => vm.isFullScreen ? 'fa-solid fa-minimize' : 'fa-solid fa-maximize',
    showBalance() {
      const isNotFullScreenDesktop = this.userDevice !== 'd' || this.isFullScreen;
      return this.isInitialBetPlayed && isNotFullScreenDesktop;
    }
  },
  watch: {
    isInitialBetPlayed: {
      handler() { this.isCentralized = (!this.isInitialBetPlayed && this.userDevice === 'm') },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .regulatory-footer-wrapper {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 32px;
    background-color: #17171b;
    color: white;
    font-size: 12px;

    .button-fullscreen {
      background-color: transparent;
      border: none;
      justify-self: end;
      cursor: pointer;
    }

    @media screen and (max-width: 800px)  {
      font-size: 8px;
    }
  }

  .centralized {
    justify-content: center;
  }
</style>
